import React from 'react';
import clx from "classnames";
import { useState } from "react"
import {  FiMoon, FiSettings, FiSun, FiX } from 'react-icons/fi'
import supportStore from '../../stores/useSupport';
import { useGeneral } from '../../stores/useGeneral';
 
export const Customization = () => {
    const {darkmode, setMode} = useGeneral(state=>state);
    const [customization, setCustomization] = useState(false)

    const [dir, setDir] = useState(false)
    const [status, setStatus] = useState(false)
    const {primaryColor, setColor, wallpaper, setWallpaper, gradient, 
      setGradient, pattern, setPattern} = supportStore(state=>state)

    return (
      <section class="relative">
      <div 
      onClick={()=>setCustomization(!customization)}
      class={clx(
        `bg-${primaryColor}-${primaryColor=='green'?'400':'500'}`,
        `fixed right-2 shadow-lg rounded-lg top-[45%] h-14 w-14 z-[100] 
         flex items-center justify-center cursor-pointer`
      )}>
       <FiSettings size={23} class="h-12 text-white animate-spin" /> 
      </div>
      <div  
        className={clx({'hidden':!customization},`fixed top-0 overflow-y-auto right-0 p-5 pt-0 z-[55] dark:text-white w-96 dark:bg-zinc-900 bg-white shadow-lg h-screen`)}
      >
          <div class="flex justify-between items-center">
              <div class="text-2xl">Settings</div>
              <div class="flex gap-2 items-center">
                <div 
                 onClick={()=>{
                    pattern='';
                    gradient='';
                    wallpaper='';
                    photo='';
                    pattern_position='';
                 }}
                class="relative">
                  
                  <span class="flex h-2 w-2 absolute -top-1 -right-1">
                      <span class="animate animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                      <span class="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
                  </span>
                  
                  
                  <div class="hidden absolute right-0 -top-2 h-2 w-2 bg-blue-500 rounded-full"></div>
                  <svg class="h-6 cursor-pointer" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none"><path fill="#fff" fill-opacity="0.01" d="M2 4v6h6"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2 10s2.005-2.7318 3.6338-4.3618C7.2627 4.0082 9.5136 3 12 3c4.9706 0 9 4.0294 9 9s-4.0294 9-9 9c-4.103 0-7.5649-2.7457-8.6482-6.5M2 10V4m0 6h6"></path></svg>
                </div>
                <div onClick={()=>setCustomization(false)} >
                  <FiX size={23} class="h-14 cursor-pointer" /> 
                </div>
              </div>
          </div>
          <div>
            <h3 class="text-gray-500 mb-3">Primary color</h3>
            <ul>
              {[
              {name:'green', sample:'bg-green-400' },
              {name:'blue', sample:'bg-blue-500' },
              {name:'yellow', sample:'bg-yellow-400' },
              {name:'red', sample:'bg-red-400' },
              {name:'zinc', sample:'bg-zinc-400' },
              ].map(color=>(
                <li 
                  onClick={()=>setColor(color.name)}
                  class={clx(
                    primaryColor==color.name&&'dark:border-zinc-500 border-zinc-300 bg-zinc-100 dark:bg-gray-800',
                    `float-left mr-2 mb-2 gray-bg-300 border-transparent border-2 dark:border-zinc-700 border-zinc-300 hover:bg-gray-200 dark:bg-zinc-800 dark:hover:bg-gray-800 w-max rounded-full flex items-center justify-center cursor-pointer`
                  )} >  
                    <div class="flex gap-2 items-center rounded-full px-3 p-1"> 
                        <div class={clx(color.sample, `h-5 w-5 rounded-full`)} ></div> 
                        <p class="font-medium" x-text="color.name">Green</p>
                    </div>
                  </li>
              ))}
            </ul>
          </div>

          <div class="clear-both"></div>
          <div>
            <h3 class="text-gray-500 mb-3">Color scheme</h3>
            <ul >
              <li 
              onClick={()=>setMode('dark')}
              class={clx(
                darkmode=='dark' ? 'dark:border-zinc-500 dark:bg-gray-800 border-zinc-300 bg-zinc-100': 
                'dark:border-zinc-700 border-zinc-200 hover:bg-gray-200 dark:bg-zinc-800 dark:hover:bg-gray-800 ',
                'border float-left mr-2 mb-2 gray-bg-300 border-transparent border-2 w-max rounded-full flex items-center justify-center cursor-pointer'
              )}>  
                <div class="flex items-center gap-1 rounded-full px-4 p-1"> 
                   <FiMoon size={23} class="h-4" /> 
                    <p class="font-medium">Dark</p>
                </div>
              </li>
              <li 
              onClick={()=>setMode('light')}
              class={clx(
                darkmode=='light' ? 'dark:border-zinc-500 dark:bg-gray-800 border-zinc-300 bg-zinc-100': 
                'dark:border-zinc-700 border-zinc-200 hover:bg-gray-200 dark:bg-zinc-800 dark:hover:bg-gray-800 ',
                'border float-left mr-2 mb-2 gray-bg-300 border-transparent border-2 w-max rounded-full flex items-center justify-center cursor-pointer'
              )}>  
              <div class="flex items-center gap-1 rounded-full px-4 p-1"> 
                  <FiSun size={25} class="h-4" /> 
                    <p class="font-medium">Light</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="clear-both"></div>
          <div>
            <h3 class="text-gray-500 mb-3">Orientation</h3>
            <ul x-data="{dir:'ltr'}">
              <li 
              class={clx(
                'float-left mr-2 mb-2 gray-bg-300 border-transparent border-2 dark:border-zinc-700 border-zinc-200 hover:bg-gray-200 dark:bg-zinc-800 dark:hover:bg-gray-800 w-max rounded-full flex items-center justify-center cursor-pointer',
                dir=='ltr'&&'dark:border-zinc-500 dark:bg-gray-800 border-zinc-300 bg-zinc-100 '
              )}>  
                <div class="flex items-center gap-1 rounded-full px-4 p-1"> 
                    <p class="font-medium">Left to right</p>
                </div>
              </li>
              <li 
              class={clx(
                dir=='rtl'&&'dark:border-zinc-500 dark:bg-gray-800 border-zinc-300 bg-zinc-100 ',
                'float-left mr-2 mb-2 gray-bg-300 border-transparent border-2 dark:border-zinc-700 border-zinc-200 hover:bg-gray-200 dark:bg-zinc-800 dark:hover:bg-gray-800 w-max rounded-full flex items-center justify-center cursor-pointer'
              )}>  
              <div class="flex items-center gap-1 rounded-full px-4 p-1"> 
                    <p class="font-medium">Right to left</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="clear-both"></div> 
          <div class="relative">
            <div class="">
            <h3 class="text-gray-500 mb-3">Wallpapers</h3>
            <div>              
              <h4 class="text-gray-500 my-3 text-sm">Light</h4>
               <div 
               class={clx(
                'grid grid-cols-4 gap-2 mb-2 content_mask',
                !status?`masked ${darkmode}`:'open'
              )}>
                {light_colors.map(color=>(
                   <React.Fragment>
                    <img src={`/images/${color.path}`} 
                    onClick={()=>setWallpaper({path:`/images/${color.path}`, position:color.position})} class="w-full h-full bg-cover cursor-pointer" />
                  </React.Fragment>
                ))}
                <img  onClick={()=>{ // wallpaper={path:''}
                }} class="w-full h-full bg-cover cursor-pointer" />

                <div
                 onClick={()=>setStatus(!status)}
                 className={clx(
                  !status?'more':'less'
                 )}
                >{!status?'Read more':'Read less'}</div>
              </div>
      
              <h4 class="text-gray-500 my-3 text-sm ">Dark</h4>
              <div 
              x-data="{status:false}"
              class={clx(
                'grid grid-cols-4 gap-2 mb-2 content_mask',
                !status?`masked ${darkmode}`:'open'
              )}>
                {dark_colors.map(color=>(
                  <React.Fragment>
                  <img src={`/images/${color.path}`} 
                    onClick={()=>setWallpaper({path:`/images/${color.path}`, position:color.position})} class="w-full h-full bg-cover cursor-pointer" />
                  </React.Fragment>
                ))}
                <img onClick="wallpaper=''" class="w-full h-full bg-cover cursor-pointer" />

                <div
                 onClick={()=>setStatus(!status)}
                 className={!status?'more':'less'} >{!status?'Read more':'Read less'}</div>
              </div>
              {/* 
                <div class="flex gap-2">
                <img src="./assets/images/wallpapers/dark/1.jpg" @click="wallpaper='./assets/images/wallpapers/dark/1.jpg'" class="w-20 cursor-pointer" >
                <img src="./assets/images/wallpapers/dark/2.jpg" @click="wallpaper='./assets/images/wallpapers/dark/2.jpg'" class="w-20 cursor-pointer" >
                <img src="./assets/images/wallpapers/dark/3.jpg" @click="wallpaper='./assets/images/wallpapers/dark/3.jpg'" class="w-20 cursor-pointer" >
                <img src="./assets/images/wallpapers/dark/4.jpg" @click="wallpaper='./assets/images/wallpapers/dark/4.jpg'" class="w-20 cursor-pointer" >
              </div>
              */}
 
                    
            <h4 class="text-gray-500 my-3 text-sm ">Patterns</h4>

            <ul class="grid grid-cols-6 gap-2">

              {patterns.map(shape=>(
                <li 
                onClick={()=>setPattern(`/images/patterns/${shape}.svg`)}
                class={clx(
                  pattern==`/images/patterns/${shape}.svg`&&'bg-gray-200 border-2',
                  'flex items-center justify-center bg-gray-200 dark:bg-zinc-700 hover:bg-gray-300 rounded-lg w-12 h-12'
                )}> 
                  <img src={`/images/patterns/${shape}.svg`} class="object-contain cursor-pointer" /> 
                </li>
              ))}

              <li 
              onClick={()=>setPattern('')}
              class="flex items-center justify-center bg-gray-200 dark:bg-zinc-700 hover:bg-gray-300 rounded-lg w-12 h-12"> 
              </li>
            </ul>
      
          <h4 class="text-gray-500 my-3 text-sm ">Gradients</h4>
            <ul class="grid grid-cols-6 gap-2 gradients">
              {colors.map(color=>(
                 <React.Fragment>
                  <li 
                  onClick={()=>{
                    setWallpaper('')
                    setGradient(color)
                  }}
                  class={clx(color, ' flex items-center justify-rounded-lg w-12 h-12 cursor-pointer')}> </li>
                </React.Fragment>
              ))}
              <li 
              onClick={()=>setGradient('')}
              class=" border border-2 border-gray-500 rounded-lg flex items-center justify-center w-12 h-12 cursor-pointer"> </li>
            </ul>

 
            <h4 class="text-gray-500 my-3 text-sm ">Templates</h4>
            <ul class="grid grid-cols-6 gap-2 gradients">
              {templates.map(template=>(
                 <React.Fragment>
                  <li 
                  onClick={()=>{  
                    setColor(template.color)
                    setMode(template.darkmode?'dark':'light')
                    template.pattern && setPattern(`/images/patterns/${template.pattern}.svg`)
                   
                    setPattern(`/images/patterns/${template.pattern}.svg`)
                    if(template.wallpaper) {
                      setWallpaper({path:template.wallpaper.path, position:template.wallpaper.position})
                      setGradient('')
                      // !template.pattern && setPattern('') 
                    }
                    if(template.gradient){
                      setGradient(template.gradient)
                     setWallpaper('')
                    }
                  }}
                  style={{
                    backgroundImage:template.wallpaper&&`url(${template.wallpaper.path})`, backgroundSize:'cover'}}
                  class={clx(template.gradient,'rounde-md flex items-center relative justify-rounded-lg w-12 h-12 cursor-pointer overflow-hidden',
                  `border border-2 border-${template.color}-400`
                  )}>
                    {/** Tailwind helder **/}
                    <div className='border-red-400 border-yellow-400 border-blue-400 border-green-400 border-zinc-400'></div>
                    {template.pattern &&  <img src={`/images/patterns/${template.pattern}.svg`} class="object-cover cursor-pointer" />  }
                  </li>
                </React.Fragment>
              ))}
              <li 
              onClick={()=>{
                setGradient('')
                setWallpaper('')
                setPattern('')
              }}
              class="border border-2 border-gray-500 rounded-lg flex items-center justify-center w-12 h-12 cursor-pointer"> </li>
            </ul>
          </div>
        </div>
        </div>
          <div class="clear-both"></div>

      </div>
    </section>
    )
  }


  const light_colors = [
    {path:'livechat/gradient/1.svg', position:'cover'},
    {path:'livechat/gradient/2.svg', position:'cover'},
    {path:'livechat/gradient/3.svg', position:'cover'},
    {path:'livechat/gradient/4.svg', position:'cover'},
    {path:'livechat/gradient/6.svg', position:'cover'},
    {path:'livechat/gradient/7.svg', position:'cover'},
    {path:'wallpapers/light/1.jpg', position:'contain'},
    {path:'wallpapers/light/2.jpg', position:'cover'},
    {path:'livechat/gradient/8.svg', position:'cover'},
    {path:'wallpapers/light/3.jpg', position:'contain'},
    {path:'wallpapers/light/4.jpg', position:'contain'},
  ]

  const dark_colors = [
    {path:'livechat/gradient/10.svg', position:'cover'},
    {path:'wallpapers/dark/1.jpg', position:'cover'},
    {path:'wallpapers/dark/3.jpg', position:'contain'},
  ]

  const colors = [
    'rea', 'lunada', 'windy', 'petrol', 'royalblue_petrol',
    'amnisar', 'sky', 'skyline', 'dimigo', 'blooker20', 'hazel',
    'moon_to_dusk', 'harmonic_energy', 'playing_reds', 'sunny_days',
    'green_beach', 'intutive_purple', 'emerald_water', 'montecarlo' ,
    'horizon', 'route_water', 'mango_pulp'
  ]

  const patterns = [
    'glamorous', '4-point-stars', 'anchors-away', 'aztec',
    'bank-note', 'circuit-board', 'endless-clouds', 'falling-triangles',
    'hideout', 'leaf', 'polka-dots', 'tic-tac-toe', 'topography', 'wiggle'
  ]

  const templates = [
    {darkmode:true, color:'green', pattern:'aztec', gradient:'royalblue_petrol'},
    {darkmode:true, color:'blue', wallpaper:{path:'/images/wallpapers/dark/1.jpg', position:'cover'}},
    {darkmode:true, color:'green', wallpaper:{path:'/images/wallpapers/dark/1.jpg', position:'cover'}},
    {darkmode:true, color:'zinc' },
    {darkmode:false, color:'blue', wallpaper:{path:'/images/livechat/gradient/5.svg', position:'cover'}},
    {darkmode:false, color:'green', wallpaper:{path:'/images/livechat/gradient/6.svg', position:'cover'}},
    {darkmode:false, color:'red', wallpaper:{path:'/images/livechat/gradient/1.svg', position:'cover'}, pattern:'wiggle'},
    {darkmode:false, color:'blue', wallpaper:{path:'/images/wallpapers/light/2.jpg', position:'cover'}},
    {darkmode:false, color:'green', wallpaper:{path:'/images/wallpapers/light/1.jpg', position:'cover'}},
    {darkmode:false, color:'zinc', wallpaper:{path:'/images/livechat/gradient/7.svg', position:'cover'}, pattern:'bank-note'},
    {darkmode:false, color:'yellow', wallpaper:{path:'/images/livechat/gradient/6.svg', position:'cover'}, pattern:'tic-tac-toe'},
    {darkmode:false, color:'yellow', wallpaper:{path:'/images/livechat/gradient/3.svg', position:'cover'}, pattern:'circuit-board'},
    {darkmode:false, color:'green', wallpaper:{path:'/images/livechat/gradient/3.svg', position:'cover', pattern:'glamorous'}},
    {darkmode:false, color:'blue', wallpaper:{path:'/images/livechat/gradient/7.svg', position:'cover'},pattern:'topography'},
    {darkmode:false, color:'blue', wallpaper:{path:'/images/livechat/gradient/6.svg', position:'cover'},pattern:'glamorous'},
    {darkmode:false, color:'green', wallpaper:{path:'/images/livechat/gradient/3.svg', position:'cover'},pattern:'anchors-away'},
    {darkmode:true, color:'yellow', wallpaper:{path:'', position:'cover'}, gradient:''},
    {darkmode:true, color:'yellow', gradient:'emerald_water', pattern:'endless-clouds'},
    {darkmode:true, color:'green', wallpaper:{path:'/images/wallpapers/light/1.jpg', position:'contain'} },
    {darkmode:true, color:'red', gradient:'moon_to_dusk', pattern:'polka-dots' },
    {darkmode:true, color:'red', wallpaper:{path:'/images/livechat/gradient/1.svg', position:'cover'}, pattern:'endless-clouds' },
    {darkmode:true, color:'green', pattern:'falling-triangles', gradient:'royalblue_petrol' },
    {darkmode:true, color:'blue', wallpaper:{path:'/images/wallpapers/light/2.jpg', position:'cover'},  },
    {darkmode:true, color:'zinc', gradient:'petrol' },
    {darkmode:true, color:'blue', gradient:'_' },

  ]

    
  // falling-triangles